<script>
import ErrorUi from "./ErrorUi";

export default {
  name: "NotFound",
  components: {
    ErrorUi,
  },
};
</script>

<template>
  <ErrorUi />
</template>
